import { createFileRoute } from "@tanstack/react-router";
import { useMe } from "../api/hooks.ts";
import { CreateLocation } from "../components/network/create-location.tsx";
import { useT } from "../lib/locale.ts";

export const Route = createFileRoute("/natverk/ny")({ component: Screen });

function Screen() {
  const t = useT();
  const me = useMe();

  if (me.data !== undefined && !me.data.network_permissions.includes("franchise:create")) {
    return (
      <div className="flex flex-1 items-center justify-center p-6">
        <p className="text-body-sm text-muted-foreground">{t("error.forbidden")}</p>
      </div>
    );
  }

  return <CreateLocation />;
}
